/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import db from "../../../db"
import { currentUser } from "../../../fb"

// reactstrap components
import {
    Button,
    Container,
    Row,
    Col,
} from "reactstrap";

// core components
import Event from "./Event"
import EventForm from "../../Admin/Events/EventForm"
import Search from "../../SearchForm"
import CustomPagination from "../../CustomPagination"

// admin = true means this Component is being called via the AdminEvents.js 
function Events({ admin = false, size, events, }) {

    // What is going to be displayed. 
    // Necessary since there is a search and pagination
    const [displayed, setDisplayed] = useState([])
    useEffect(() => setDisplayed(events?.filter((event) => event.isDisplayed || currentUser() !== null)), [])

    const [categories, setCategories] = useState([])
    useEffect(() => db.EventCategories.listenAll(setCategories), [])

    const del = (event) => {
        setTimeout(async () => {
            await db.Events.removeEventImages(event)
            await db.Events.remove(event.id)
        }, 500)
    }

    // The event that is going to be edited
    // Flow: Edit button in <Event/> is pressed => event state changes
    // => event state is passed to <EventForm/> => Necessary states gets set
    // => Inputs are automatically filled
    const [event, setEvent] = useState(null)
    const [flag, setFlag] = useState(false)
    const [deleted, setDeleted] = useState([])

    // Search
    const [searchResults, setSearchResults] = useState([])
    const fields = () =>
        Object.keys(events[0]).reduce((acc, key) => { return (typeof (events[0][key]) !== "object") ? acc.concat([{ value: key, label: key }]) : acc }, [])

    // Pagination
    const [page, setPage] = useState(1)
    // Edit this to dictate how many items per page will be shown
    const [itemsPerPage] = useState(15)
    // Calculates the index range of which items to show
    useEffect(() => {
        if (searchResults.length === 0) {
            setDisplayed(events?.slice((page - 1) * itemsPerPage, page * itemsPerPage))
        }
        else {
            setDisplayed(searchResults?.slice((page - 1) * itemsPerPage, page * itemsPerPage))
        }
    }, [page, searchResults, events?.length])

    return (
        <>
            <div className="section section-dark" id="edit" style={{ minHeight: "100vh" }}>
                <div className="projects-3 " id="projects-3" style={{ paddingTop: 0, height: "auto" }}>
                    <Container style={{ minWidth: "100%" }}>
                        <Row>
                            <Col className="ml-auto mr-auto text-center" md="8">
                                <div className="space-top" />
                                <h2 className="title">{!admin ? "Some of Our Awesome Projects" : "All Events"}</h2>
                                {
                                    currentUser() ?
                                        !admin ?
                                            <Link to="/admin/events">
                                                <Button
                                                    color="danger"
                                                >
                                                    Edit Events
                                            </Button>
                                            </Link>
                                            :
                                            categories && categories.length > 0 &&
                                            <EventForm
                                                categoryOptions={categories.map((option) => { return { value: option.id, label: option.name } })}
                                                selectedEvent={event}
                                                setSelectedEvent={setEvent}
                                                flag={flag}
                                                setSearchResults={setSearchResults}
                                                deleted={deleted}
                                                setDeleted={setDeleted}
                                            />
                                        :
                                        null
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col className="ml-auto mr-auto text-center" lg="8" md="8" sm="12" xs="12">
                                {
                                    (currentUser() && admin && events?.length > 0) &&
                                    <Search
                                        fields={fields}
                                        setSearchResults={setSearchResults}
                                        searchList={events}
                                    />
                                }
                            </Col>
                        </Row>
                        <Row>
                            <div className="space-top" />
                            {
                                displayed && displayed.map((event) =>
                                    (admin || event && event.isDisplayed) &&
                                    <Event
                                        {...event}
                                        key={event.id}
                                        size={size}
                                        admin={admin}
                                        event={event}
                                        setEvent={setEvent}
                                        del={del}
                                        flag={flag}
                                        setFlag={setFlag}
                                        setDeleted={setDeleted}
                                    />
                                )
                            }
                        </Row>
                        {
                            events && events.length > 0 &&
                            <Row>
                                <Col className="flex-centered">
                                    <div className="space-top" />
                                    <CustomPagination
                                        array={searchResults.length > 0 ? searchResults : events}
                                        setPage={setPage}
                                        itemsPerPage={itemsPerPage}
                                    />
                                </Col>
                            </Row>
                        }
                    </Container>
                </div>
            </div>
        </>
    );
}

export default Events;
